import {createContext} from 'react'

const CatTipoSolicitudCompraContext = createContext()

export default CatTipoSolicitudCompraContext